export const JWT = 'jwt';
export const DEFAULT_USER_EMAIL = 'default@gamsplatform.com';
export const JSON_LIST_SEPARATOR = '&&';